// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessagesModal_modal__EPpIW .modal__inner {
  max-width: none;
  width: auto;
}
.MessagesModal_modal__EPpIW .modal__header {
  min-height: 52px;
  padding: 0;
}
.MessagesModal_modal__EPpIW .modal__title {
  margin-right: auto;
}
.MessagesModal_modal__EPpIW .modal__title::first-letter {
  text-transform: capitalize;
}
.MessagesModal_modal__EPpIW .modal__body {
  padding: 0;
}

.MessagesModal_headerSlice__1QppT {
  display: flex;
  align-items: center;
  min-height: 52px;
  padding: 12px;
}

.MessagesModal_headerSliceAside__HIsB1 {
  width: var(--modal-aside-width);
  flex-shrink: 0;
  border-right: 1px solid #E0E7EB;
  align-self: stretch;
}

.MessagesModal_headerSliceMain__5niY2 {
  width: calc(var(--modal-chats-body-width) - 44px);
}
.MessagesModal_headerSliceMain--is-info-open__yNLOH {
  width: calc(var(--modal-chats-body-width) - 44px + var(--modal-chats-info-width));
}

.MessagesModal_titleName__5DJag {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.MessagesModal_headerChatWrap__FnAoJ {
  position: relative;
}

.MessagesModal_separator__rnPbV {
  width: 1px;
  background-color: #E0E7EB;
  flex-shrink: 0;
  align-self: stretch;
  margin-left: 16px;
}

.MessagesModal_main__8rJJ3 {
  display: flex;
}

.MessagesModal_aside__Ahqfq {
  width: var(--modal-aside-width);
  flex-shrink: 0;
  border-right: 1px solid #E0E7EB;
  min-height: 526px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-bottom-left-radius: 16px;
  padding: 4px 0 0;
}

.MessagesModal_asideList__Y4PCe {
  height: auto;
  flex: 1 1;
}

.MessagesModal_chat__c8M5Q {
  width: var(--modal-chats-body-width);
  flex-shrink: 0;
}

.MessagesModal_dummyChat__a0l7v {
  width: var(--modal-chats-body-width);
  min-height: 592px;
  border-bottom-right-radius: 16px;
  width: 100%;
}

.MessagesModal_dummyChat__a0l7v {
  background-color: var(--white);
}

.MessagesModal_listLoader__ikoIO {
  display: flex;
  align-items: center;
  height: 57px;
  padding: 8px;
}
.MessagesModal_listLoader__avatar__hb5z3 {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 8px;
}
.MessagesModal_listLoader__name__zcbDM, .MessagesModal_listLoader__txt__SUqvm {
  border-radius: 4px;
}
.MessagesModal_listLoader__name__zcbDM {
  width: 100px;
  height: 14px;
  margin-bottom: 1px;
}
.MessagesModal_listLoader__txt__SUqvm {
  height: 11px;
}

.MessagesModal_orderLoader__LKFBj {
  height: 100%;
  border-bottom-right-radius: 16px;
}

.MessagesModal_info__l-t4K {
  width: var(--modal-chats-info-width);
  flex-shrink: 0;
  border-left: 1px solid #E0E7EB;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.MessagesModal_infoFooter__psNQW {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #E0E7EB;
  min-height: var(--modal-footer-height);
  padding: 8px;
}

.MessagesModal_btnInfo--is-open__Eogt- {
  background-color: rgba(var(--accent-color-rgb), 0.1);
  color: var(--accent-color);
}

.MessagesModal_mobileBtnInfo__N-mbt {
  padding: 6px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1607843137);
}
.MessagesModal_mobileBtnInfo__N-mbt svg {
  fill: none;
}

div.MessagesModal_search__-yGQE {
  width: auto;
  margin: 0 8px 4px;
}
div.MessagesModal_search__-yGQE input {
  letter-spacing: normal;
  padding-left: 6px;
}

.MessagesModal_noChatList__Cvx2J {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 114%;
  margin: auto;
  width: 100%;
  position: absolute;
  top: 50%;
}
@media (min-width: 1200px) {
  .MessagesModal_noChatList__Cvx2J {
    margin-top: 20px;
    position: initial;
  }
}

.MessagesModal_modal-mobile__7SV-A {
  padding: 0;
  z-index: 3;
}
.MessagesModal_modal-mobile__7SV-A .modal__inner {
  width: 100%;
  height: 100%;
  border-radius: 0;
  display: flex;
  flex-direction: column;
  background: #FAFAFA;
}
.MessagesModal_modal-mobile__7SV-A .modal__inner .modal__header {
  min-height: auto;
  border: 0;
  padding: 24px 16px;
}
.MessagesModal_modal-mobile__7SV-A .modal__body {
  height: 100%;
}
.MessagesModal_modal-mobile__7SV-A aside {
  width: 100%;
  border: none;
  padding: 0;
  gap: 18px;
}
.MessagesModal_modal-mobile__7SV-A aside .searchBlock {
  margin: 0 16px;
}
.MessagesModal_modal-mobile__7SV-A aside .searchBlock input {
  padding: 0 16px;
}
.MessagesModal_modal-mobile__7SV-A aside .asideList .ScrollbarsCustom-Content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 6px 16px 24px;
  height: calc(100% - 40px);
}
.MessagesModal_modal-mobile__7SV-A.MessagesModal_mobile-chat__opened__ggPA0 .modal__body {
  padding: 0;
  width: 100%;
  height: 100%;
}
.MessagesModal_modal-mobile__7SV-A.MessagesModal_mobile-chat__opened__ggPA0 .modal__inner .modal__header {
  border-bottom: 1px solid #EFF3F5;
}
.MessagesModal_modal-mobile__7SV-A.MessagesModal_mobile-chat__opened__ggPA0 .MessagesModal_main__8rJJ3 {
  height: 100%;
  position: relative;
}
.MessagesModal_modal-mobile__7SV-A.MessagesModal_mobile-chat__opened__ggPA0 .MessagesModal_main__8rJJ3 .MessagesModal_chat__c8M5Q {
  width: 100%;
  position: absolute;
  height: -webkit-fill-available;
  overflow: hidden;
}
.MessagesModal_modal-mobile__7SV-A.MessagesModal_mobile-chat__opened__ggPA0 .MessagesModal_main__8rJJ3 .messages-loader {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
}
.MessagesModal_modal-mobile__7SV-A .MessagesModal_main__8rJJ3 {
  height: 100%;
}
.MessagesModal_modal-mobile__7SV-A .MessagesModal_header-container__s4gDW {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.MessagesModal_modal-mobile__7SV-A .MessagesModal_mobile-info__2muj4 {
  position: absolute;
  background: #FAFAFA;
  width: 100%;
  height: 100%;
  z-index: 5;
  padding: 0 16px 24px;
  border: none;
  overflow: auto;
}
.MessagesModal_modal-mobile__7SV-A .MessagesModal_mobile-info__2muj4 .MessagesModal_infoFooter__psNQW {
  border: none;
  display: flex;
  gap: 8px;
  padding: 0;
  min-height: auto;
}
.MessagesModal_modal-mobile__7SV-A .MessagesModal_mobile-info__2muj4 .MessagesModal_infoFooter__psNQW button {
  height: 44px;
}
.MessagesModal_modal-mobile__7SV-A .MessagesModal_mobile-info__2muj4 .MessagesModal_infoFooter__psNQW .MessagesModal_back-btn__qeg\\+c {
  max-width: 33%;
}

.MessagesModal_callback-modal__cYJNT {
  align-items: flex-end;
  padding: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/MessagesModal/MessagesModal.module.scss"],"names":[],"mappings":"AAGM;EACE,eAAA;EACA,WAAA;AAFR;AAKM;EACE,gBAAA;EACA,UAAA;AAHR;AAMM;EACE,kBAAA;AAJR;AAMQ;EACE,0BAAA;AAJV;AAWM;EACE,UAAA;AATR;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;AAZF;;AAeA;EACE,+BAAA;EACA,cAAA;EACA,+BAAA;EACA,mBAAA;AAZF;;AAeA;EACE,iDAAA;AAZF;AAcE;EACE,iFAAA;AAZJ;;AAgBA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAbF;;AAgBA;EACE,kBAAA;AAbF;;AAgBA;EACE,UAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AAbF;;AAgBA;EACE,aAAA;AAbF;;AAgBA;EACE,+BAAA;EACA,cAAA;EACA,+BAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,+BAAA;EACA,gBAAA;AAbF;;AAgBA;EACE,YAAA;EACA,SAAA;AAbF;;AAgBA;EACE,oCAAA;EACA,cAAA;AAbF;;AAgBA;EACE,oCAAA;EACA,iBAAA;EACA,gCAAA;EACA,WAAA;AAbF;;AAgBA;EACE,8BAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AAbF;AAeE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAbJ;AAgBE;EAEE,kBAAA;AAfJ;AAkBE;EACE,YAAA;EACA,YAAA;EACA,kBAAA;AAhBJ;AAmBE;EACE,YAAA;AAjBJ;;AAqBA;EACE,YAAA;EACA,gCAAA;AAlBF;;AAqBA;EACE,oCAAA;EACA,cAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAlBF;;AAqBA;EACE,cAAA;EACA,aAAA;EACA,yBAAA;EACA,6BAAA;EACA,sCAAA;EACA,YAAA;AAlBF;;AAsBE;EACE,oDAAA;EACA,0BAAA;AAnBJ;;AAuBA;EACE,YAAA;EACA,uDAAA;AApBF;AAsBE;EACE,UAAA;AApBJ;;AAwBA;EACE,WAAA;EACA,iBAAA;AArBF;AAuBE;EACE,sBAAA;EACA,iBAAA;AArBJ;;AAyBA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;AAtBF;AAwBE;EAVF;IAWI,gBAAA;IACA,iBAAA;EArBF;AACF;;AAwBA;EACE,UAAA;EACA,UAAA;AArBF;AAwBI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAtBN;AAwBM;EACE,gBAAA;EACA,SAAA;EACA,kBAAA;AAtBR;AA0BI;EACE,YAAA;AAxBN;AA2BI;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;AAzBN;AA2BM;EACE,cAAA;AAzBR;AA2BQ;EACE,eAAA;AAzBV;AA8BQ;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,sBAAA;EACA,yBAAA;AA5BV;AAoCM;EACE,UAAA;EACA,WAAA;EACA,YAAA;AAlCR;AAuCQ;EACE,gCAAA;AArCV;AA0CI;EACE,YAAA;EACA,kBAAA;AAxCN;AA0CM;EACE,WAAA;EACA,kBAAA;EACA,8BAAA;EACA,gBAAA;AAxCR;AA4CQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AA1CV;AAgDE;EACE,YAAA;AA9CJ;AAiDE;EACE,aAAA;EACA,8BAAA;EACA,WAAA;AA/CJ;AAkDE;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,YAAA;EACA,cAAA;AAhDJ;AAkDI;EACE,YAAA;EACA,aAAA;EACA,QAAA;EACA,UAAA;EACA,gBAAA;AAhDN;AAkDM;EACE,YAAA;AAhDR;AAmDM;EACE,cAAA;AAjDR;;AAuDA;EACE,qBAAA;EACA,aAAA;AApDF","sourcesContent":[".modal {\r\n  :global {\r\n    .modal {\r\n      &__inner {\r\n        max-width: none;\r\n        width: auto;\r\n      }\r\n\r\n      &__header {\r\n        min-height: 52px;\r\n        padding: 0;\r\n      }\r\n\r\n      &__title {\r\n        margin-right: auto;\r\n\r\n        &::first-letter {\r\n          text-transform: capitalize;\r\n        }\r\n      }\r\n\r\n      &__close-btn {\r\n      }\r\n\r\n      &__body {\r\n        padding: 0;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.headerSlice {\r\n  display: flex;\r\n  align-items: center;\r\n  min-height: 52px;\r\n  padding: 12px;\r\n}\r\n\r\n.headerSliceAside {\r\n  width: var(--modal-aside-width);\r\n  flex-shrink: 0;\r\n  border-right: 1px solid #E0E7EB;\r\n  align-self: stretch;\r\n}\r\n\r\n.headerSliceMain {\r\n  width: calc(var(--modal-chats-body-width) - 44px);\r\n\r\n  &--is-info-open {\r\n    width: calc(var(--modal-chats-body-width) - 44px + var(--modal-chats-info-width));\r\n  }\r\n}\r\n\r\n.titleName {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  max-width: 100%;\r\n}\r\n\r\n.headerChatWrap {\r\n  position: relative;\r\n}\r\n\r\n.separator {\r\n  width: 1px;\r\n  background-color: #E0E7EB;\r\n  flex-shrink: 0;\r\n  align-self: stretch;\r\n  margin-left: 16px;\r\n}\r\n\r\n.main {\r\n  display: flex;\r\n}\r\n\r\n.aside {\r\n  width: var(--modal-aside-width);\r\n  flex-shrink: 0;\r\n  border-right: 1px solid #E0E7EB;\r\n  min-height: 526px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  border-bottom-left-radius: 16px;\r\n  padding: 4px 0 0;\r\n}\r\n\r\n.asideList {\r\n  height: auto;\r\n  flex: 1;\r\n}\r\n\r\n.chat {\r\n  width: var(--modal-chats-body-width);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.dummyChat {\r\n  width: var(--modal-chats-body-width);\r\n  min-height: 592px;\r\n  border-bottom-right-radius: 16px;\r\n  width: 100%;\r\n}\r\n\r\n.dummyChat {\r\n  background-color: var(--white);\r\n}\r\n\r\n.listLoader {\r\n  display: flex;\r\n  align-items: center;\r\n  height: 57px;\r\n  padding: 8px;\r\n\r\n  &__avatar {\r\n    width: 40px;\r\n    height: 40px;\r\n    border-radius: 50%;\r\n    margin-right: 8px;\r\n  }\r\n\r\n  &__name,\r\n  &__txt {\r\n    border-radius: 4px;\r\n  }\r\n\r\n  &__name {\r\n    width: 100px;\r\n    height: 14px;\r\n    margin-bottom: 1px;\r\n  }\r\n\r\n  &__txt {\r\n    height: 11px;\r\n  }\r\n}\r\n\r\n.orderLoader {\r\n  height: 100%;\r\n  border-bottom-right-radius: 16px;\r\n}\r\n\r\n.info {\r\n  width: var(--modal-chats-info-width);\r\n  flex-shrink: 0;\r\n  border-left: 1px solid #E0E7EB;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n}\r\n\r\n.infoFooter {\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  border-top: 1px solid #E0E7EB;\r\n  min-height: var(--modal-footer-height);\r\n  padding: 8px;\r\n}\r\n\r\n.btnInfo {\r\n  &--is-open {\r\n    background-color: rgba(var(--accent-color-rgb), .1);\r\n    color: var(--accent-color);\r\n  }\r\n}\r\n\r\n.mobileBtnInfo {\r\n  padding: 6px;\r\n  box-shadow: 0px 4px 4px 0px #00000029;\r\n\r\n  svg {\r\n    fill: none;\r\n  }\r\n}\r\n\r\ndiv.search {\r\n  width: auto;\r\n  margin: 0 8px 4px;\r\n\r\n  input {\r\n    letter-spacing: normal;\r\n    padding-left: 6px;\r\n  }\r\n}\r\n\r\n.noChatList {\r\n  text-align: center;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  line-height: 114%;\r\n  margin: auto;\r\n  width: 100%;\r\n  position: absolute;\r\n  top: 50%;\r\n\r\n  @media (min-width: 1200px) {\r\n    margin-top: 20px;\r\n    position: initial;\r\n  }\r\n}\r\n\r\n.modal-mobile {\r\n  padding: 0;\r\n  z-index: 3;\r\n\r\n  :global {\r\n    .modal__inner {\r\n      width: 100%;\r\n      height: 100%;\r\n      border-radius: 0;\r\n      display: flex;\r\n      flex-direction: column;\r\n      background: #FAFAFA;\r\n\r\n      .modal__header {\r\n        min-height: auto;\r\n        border: 0;\r\n        padding: 24px 16px;\r\n      }\r\n    }\r\n\r\n    .modal__body {\r\n      height: 100%;\r\n    }\r\n\r\n    aside {\r\n      width: 100%;\r\n      border: none;\r\n      padding: 0;\r\n      gap: 18px;\r\n\r\n      .searchBlock {\r\n        margin: 0 16px;\r\n\r\n        input {\r\n          padding: 0 16px;\r\n        }\r\n      }\r\n\r\n      .asideList {\r\n        .ScrollbarsCustom-Content {\r\n          display: flex;\r\n          flex-direction: column;\r\n          gap: 12px;\r\n          padding: 6px 16px 24px;\r\n          height: calc(100% - 40px);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &.mobile-chat__opened {\r\n    :global {\r\n      .modal__body {\r\n        padding: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n      }\r\n\r\n      .modal__inner {\r\n\r\n        .modal__header {\r\n          border-bottom: 1px solid #EFF3F5;\r\n        }\r\n      }\r\n    }\r\n\r\n    .main {\r\n      height: 100%;\r\n      position: relative;\r\n\r\n      .chat {\r\n        width: 100%;\r\n        position: absolute;\r\n        height: -webkit-fill-available;\r\n        overflow: hidden;\r\n      }\r\n\r\n      :global {\r\n        .messages-loader {\r\n          width: 100%;\r\n          height: 100%;\r\n          position: absolute;\r\n          overflow: hidden;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .main {\r\n    height: 100%;\r\n  }\r\n\r\n  .header-container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n  }\r\n\r\n  .mobile-info {\r\n    position: absolute;\r\n    background: #FAFAFA;\r\n    width: 100%;\r\n    height: 100%;\r\n    z-index: 5;\r\n    padding: 0 16px 24px;\r\n    border: none;\r\n    overflow: auto;\r\n\r\n    .infoFooter {\r\n      border: none;\r\n      display: flex;\r\n      gap: 8px;\r\n      padding: 0;\r\n      min-height: auto;\r\n\r\n      button {\r\n        height: 44px;\r\n      }\r\n\r\n      .back-btn {\r\n        max-width: 33%;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.callback-modal {\r\n  align-items: flex-end;\r\n  padding: 12px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `MessagesModal_modal__EPpIW`,
	"headerSlice": `MessagesModal_headerSlice__1QppT`,
	"headerSliceAside": `MessagesModal_headerSliceAside__HIsB1`,
	"headerSliceMain": `MessagesModal_headerSliceMain__5niY2`,
	"headerSliceMain--is-info-open": `MessagesModal_headerSliceMain--is-info-open__yNLOH`,
	"titleName": `MessagesModal_titleName__5DJag`,
	"headerChatWrap": `MessagesModal_headerChatWrap__FnAoJ`,
	"separator": `MessagesModal_separator__rnPbV`,
	"main": `MessagesModal_main__8rJJ3`,
	"aside": `MessagesModal_aside__Ahqfq`,
	"asideList": `MessagesModal_asideList__Y4PCe`,
	"chat": `MessagesModal_chat__c8M5Q`,
	"dummyChat": `MessagesModal_dummyChat__a0l7v`,
	"listLoader": `MessagesModal_listLoader__ikoIO`,
	"listLoader__avatar": `MessagesModal_listLoader__avatar__hb5z3`,
	"listLoader__name": `MessagesModal_listLoader__name__zcbDM`,
	"listLoader__txt": `MessagesModal_listLoader__txt__SUqvm`,
	"orderLoader": `MessagesModal_orderLoader__LKFBj`,
	"info": `MessagesModal_info__l-t4K`,
	"infoFooter": `MessagesModal_infoFooter__psNQW`,
	"btnInfo--is-open": `MessagesModal_btnInfo--is-open__Eogt-`,
	"mobileBtnInfo": `MessagesModal_mobileBtnInfo__N-mbt`,
	"search": `MessagesModal_search__-yGQE`,
	"noChatList": `MessagesModal_noChatList__Cvx2J`,
	"modal-mobile": `MessagesModal_modal-mobile__7SV-A`,
	"mobile-chat__opened": `MessagesModal_mobile-chat__opened__ggPA0`,
	"header-container": `MessagesModal_header-container__s4gDW`,
	"mobile-info": `MessagesModal_mobile-info__2muj4`,
	"back-btn": `MessagesModal_back-btn__qeg+c`,
	"callback-modal": `MessagesModal_callback-modal__cYJNT`
};
export default ___CSS_LOADER_EXPORT___;
